import constants from 'common/constants'

import {ONBOARDING_STUDENTS_TEMPLATE} from './ActionTypes/ApiActionTypes'

/*
 * Download the Add Student template (.xlsx) built from the tenant's saved onboarding classes
 * and subjects. The saga saves the blob itself; `fileName` names it when the browser can't
 * read Content-Disposition. Failures: 409 { message } (no classes/subjects yet), 403, and
 * 404 on non-AI servers.
 *
 * `curriculumColumn` asks for the layout with a separate Curriculum column
 * (`?curriculum_column=true`): Class then holds the name without its curriculum prefix. A
 * school without curricula gets today's layout either way; the header row tells which it is.
 */
export const downloadStudentsTemplate = (curriculumColumn, onSuccess, onFailure) => {
  return {
    type: ONBOARDING_STUDENTS_TEMPLATE,
    payload: {
      apiUrl: constants.api_onboarding_students_template,
      getString: curriculumColumn ? '?curriculum_column=true' : '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      body: null,
      responseType: 'blob',
      fileName: 'Students Template.xlsx',
      onSuccess,
      onFailure,
    },
  }
}
